var INVITATION_CODE_LENGTH = 8;
var INVITATION_SUBMIT_LIMIT = 3;
var OTP_RESEND_DELAY = 2; // in minutes
var AGE_LIMIT = '18';
export { INVITATION_CODE_LENGTH, INVITATION_SUBMIT_LIMIT, OTP_RESEND_DELAY, AGE_LIMIT };